// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Loader, MultiSelect, MultiSelectProps, Text } from '@mantine/core';
import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IconChevronDown } from '@tabler/icons';
import { CustomAttributeDTO } from '../../../Types/CustomAttributeT';
import { CustomAttributeS } from '../../../Service/Context/CustomAttributeS';
import { ThemeText } from '../../../Atoms/ThemeText';
import LabelWithDescription from './LabelWithDescription';

interface Props extends MultiSelectProps {
  attribute: CustomAttributeDTO;
  initialValue?: string;
}

const MultipleChoiceInput: FC<Props> = ({ attribute, initialValue, ...rest }) => {
  const { suggestions } = attribute;
  const initialParsedValue = CustomAttributeS.parseMultipleChoiceValue(initialValue);
  const { id: eventId } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<string[]>(initialParsedValue.concat(suggestions));
  const [value, setValue] = useState<string[]>(initialParsedValue);

  const onChange = async (values: string[]) => {
    if (eventId) {
      setLoading(true);
      const valueDto = await CustomAttributeS.patchAttributeValue(attribute.id, eventId, values.join(';'));
      setLoading(false);
      if (valueDto) {
        setValue(CustomAttributeS.parseMultipleChoiceValue(valueDto.value));
      }
    }
  };

  return (
    <MultiSelect
      creatable
      searchable
      value={value}
      onChange={onChange}
      label={<LabelWithDescription attribute={attribute} />}
      icon={loading && <Loader size="xs" />}
      onCreate={(query) => {
        setData([...data, query]);
        return query;
      }}
      getCreateLabel={(query) => (
        <Text color="blue">
          {' '}
          + Hinzufügen{' '}
          <ThemeText span color="black" ml={10} weight="bolder">
            {query}
          </ThemeText>
        </Text>
      )}
      styles={{ rightSection: { pointerEvents: 'none' } }}
      rightSection={<IconChevronDown size={14} />}
      rightSectionWidth={25}
      {...rest}
      data={data}
    />
  );
};

export default MultipleChoiceInput;
